"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/apple-podcasts.svg.js",
    _path,
    _path2,
    _path3,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M17 3H7a4 4 0 00-4 4v10a4 4 0 004 4h10a4 4 0 004-4V7a4 4 0 00-4-4z",
    fill: "url(#prefix__apple_linear)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M11.45 18.76c-.54-.19-.65-.45-.87-2a9.617 9.617 0 01-.17-3.23 1.5 1.5 0 011.48-.73 1.48 1.48 0 011.48.73 9.493 9.493 0 01-.16 3.23c-.21 1.24-.27 1.57-.51 1.78a1.22 1.22 0 01-1.25.22zm-2.29-1.83a6.24 6.24 0 01-3.48-4.5 8.31 8.31 0 010-2.28A6.28 6.28 0 017.3 6.92a6.19 6.19 0 014.6-2 6.15 6.15 0 014.54 1.94 6.22 6.22 0 011.7 3.29c.09.714.09 1.436 0 2.15a6.34 6.34 0 01-2.43 4 7.63 7.63 0 01-1.75 1c-.06 0-.07-.07 0-.35.05-.44.11-.54.36-.64a6 6 0 001.51-1.08 5.721 5.721 0 001.5-2.65 7.049 7.049 0 000-2.63 5.61 5.61 0 00-4.22-4 7.08 7.08 0 00-2.25 0A5.65 5.65 0 006.53 10a8.13 8.13 0 000 2.51 5.77 5.77 0 002.4 3.38c.196.135.403.252.62.35.25.11.3.2.35.65v.34a5.172 5.172 0 01-.71-.23l-.03-.07zm0-2.44a4.44 4.44 0 01-1.4-2.24 5 5 0 010-2 4.43 4.43 0 012.86-3 5.31 5.31 0 012.19-.08 4.28 4.28 0 013.28 4.63 4.15 4.15 0 01-.91 2.16 3.78 3.78 0 01-1 .87 1.437 1.437 0 010-.46v-.45l.31-.37a3.42 3.42 0 00-.19-4.67 3.22 3.22 0 00-1.82-.93 2.32 2.32 0 00-1.08 0 3.28 3.28 0 00-1.89.94 3.42 3.42 0 00-.2 4.67l.31.37v.46a1.36 1.36 0 010 .45 2.153 2.153 0 01-.38-.27l-.08-.08zm2.1-2.49a1.39 1.39 0 01-.83-1.32 1.47 1.47 0 01.84-1.31 1.54 1.54 0 011.26 0c.373.199.654.536.78.94A1.45 1.45 0 0111.27 12h-.01z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    d: "M11.99 12.28a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12.14 12.86c.17.018.337.051.5.1.179.057.348.141.5.25a.8.8 0 01.29.32c.069.158.106.328.11.5.029.39.029.78 0 1.17-.05.61-.16 1.51-.24 2.08-.039.34-.113.675-.22 1a.9.9 0 01-.3.41.911.911 0 01-.37.18 1.464 1.464 0 01-.35 0 1.506 1.506 0 01-.35 0 1.18 1.18 0 01-.45-.2 1.05 1.05 0 01-.3-.46 5.249 5.249 0 01-.19-1c-.08-.49-.17-1.22-.23-1.78s-.09-.94-.09-1.2a1.771 1.771 0 010-.51 1 1 0 01.39-.57.69.69 0 01.28-.15c.12-.014.24-.014.36 0l.43-.07a.34.34 0 01.2 0l.03-.07z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  })), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__apple_linear",
    x1: 12.08,
    y1: 21.22,
    x2: 11.92,
    y2: 3,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#78479C",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B17BB5",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;